import { render, staticRenderFns } from "./incident-data.html?vue&type=template&id=50e9d7b1&scoped=true&external"
import script from "./incident-data.vue?vue&type=script&lang=js"
export * from "./incident-data.vue?vue&type=script&lang=js"
import style0 from "./incident-data.scss?vue&type=style&index=0&id=50e9d7b1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9d7b1",
  null
  
)

export default component.exports